import axios from 'axios';
// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  async getUmkmPage({ commit }, params) {
    try {
      const response = await axios.get(
        'umkm/getUMKM?pagenumber=' +
          params.page +
          '&namaumkm=' +
          params.namaUMKM
      );

      commit('GET_UMKM_PAGE', response.data.data.items);
      commit('GET_TOTAL_DATA', response.data.data.total);

      return response;
    } catch (e) {
      return e;
    }
  },
  async uploadUmkm({ commit }, params) {
    try {
      const response = await axios.post('umkm/import', params.data);

      return response;
    } catch (e) {
      return e;
    }
  },
  async uploadUmkmNew({ commit }, params) {
    try {
      const response = await axios.post('umkm/importnew', params.data);

      return response;
    } catch (e) {
      return e;
    }
  },
};
